module.exports = __webpack_public_path__ + "media/images/shark/Francis-p-800-8bb745caf13eef679f8e8a2006787b63.jpeg";